<mat-toolbar class="d-flex justify-content-between">
    <a routerLink="/bai" style="text-decoration: none; color: black;">
        <span>Bai Developer bookmark</span>
    </a>
</mat-toolbar>

<div class="container d-flex justify-content-center">
    <comp-login-form (form_submit)="login($event)" class="mt-5"></comp-login-form>
</div>
